// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1RQ7L","right":"Footer_right__32R1F","buttons":"Footer_buttons__3jHrs"};